console.log('page-assets/article/article.js is loaded!!!!');

    $('.article-content iframe, .article-content .instagram-media, .article-content .tiktok-embed').each(function () { 
        console.log('instagram-media foreach enter');
        if ($(this).is('iframe') && ($(this).attr('src').indexOf('facebook.com') > -1) ) {
                if ($(this).siblings('p').length < 1  ){
                    $(this).parent('p, div').addClass('embed');
                } else {
                    $(this).wrap( "<div class='embed'></div>" );
                }
        };
                
        if (    $(this).is('iframe') && 
                ($(this).parent('.video-embedded').length < 1 ) &&
                ( ($(this).attr('src').indexOf('youtube.com') > -1) || 
                  ($(this).attr('src').indexOf('vbox7.com') > -1) ) 
        ) {
                if ($(this).siblings('p').length < 1  ){
                    $(this).parent('p, div').addClass('video-content video-embedded');
                } else {
                    $(this).wrap( "<div class='video-content video-embedded'></div>" );
                }
        };
                
        if ($(this).is('.tiktok-embed, .instagram-media')) {
            if ( $(this).siblings('p').length >= 1  ) {
                $(this).wrap( "<div class='embed'></div>" );
            } else {
                $(this).parent('p, div').addClass('embed');               
            }
        };
        
    });

    
    $('.article-content > p, .article-content > div').toArray().forEach(el => {
        //console.log('.article-content > div.article-content > div');
        if (!el.childNodes.length || [...el.childNodes].every(node => 
            node.nodeType === Node.COMMENT_NODE || 
            (node.nodeType === Node.TEXT_NODE && !node.nodeValue.trim())
        )) {
            $(el).remove(); // Removes empty elements
        }
    });
    
    $('.article-content > div > *').toArray().forEach(el => {
        if (!el.childNodes.length || [...el.childNodes].every(node => 
            node.nodeType === Node.COMMENT_NODE || 
            (node.nodeType === Node.TEXT_NODE && !node.nodeValue.trim())
        )) {
            $(el).remove(); // Removes empty elements
        }
    });
    
    
    $('.article-content').toArray().forEach(contentEl => {
        [...contentEl.childNodes].forEach(node => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().length) {
          const p = document.createElement('p');
          p.textContent = node.textContent;
          contentEl.replaceChild(p, node);
        }
      });
    });
    
    //for desktop, sticks left block related news for all the height available
    if (document.documentElement.clientWidth > 1308) {
        let rowSpan = 1;
        $('.article-content > .position-left-col-block.pos-row-2')
        .nextUntil('.video-content, figure, blockquote, .gallery, .card.size-xl')
        .each(function () {
            if ( $(this).is('p:not(.hidden)') ) {
                rowSpan ++;
            }
        });
        if (rowSpan > 2){
            $('.article-content > .position-left-col-block.pos-row-2').css('grid-row','span ' + rowSpan);
        }
    }
    

